import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[digitsOnlyInput]' })
export class DigitsOnlyInputDirective {
  private readonly ngControl = inject(NgControl);
  private readonly digitsRegex = /[^0-9]/g;

  @HostListener('input', ['$event.target'])
  public onInput(input: HTMLInputElement): void {
    if (!input.value) {
      return;
    }

    let value = input.value;

    if (this.digitsRegex.test(value)) {
      value = value.replace(this.digitsRegex, '');
    }

    if (value !== input.value) {
      this.ngControl.control.setValue(value);
    }
  }
}
